import { useRouter, useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export default function usePreNavState<T>(
  storageKey: string,
  dataFn: () => T,
  restoreFn: (data: T) => void = () => {
    /* No-op */
  }
) {
  const state = useRef<T | null>(null);
  const router = useRouter();
  const href = useRouterState({ select: (s) => s.location.href });

  const resetState = () => {
    state.current = null;
  };

  const getStateAndReset = () => {
    const returnState = state.current;
    resetState();
    return returnState;
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: its fine
  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem(storageKey) || "{}");

    if (data.path === href) {
      state.current = data.data;
      restoreFn(state.current as T);
    } else {
      resetState();
    }

    const unsub = router.subscribe("onBeforeNavigate", () => {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          data: dataFn(),
          path: href,
        })
      );
    });

    return unsub;
  }, [href, storageKey, router, dataFn, restoreFn]);

  return {
    getStateAndReset,
    resetState,
    state: state.current,
  };
}
